import React, { useCallback } from "react";
import { Icon } from "@ddm-design-system/icon";
import { Body } from "@ddm-design-system/typography";
import classnames from "classnames";
import { IOutlet } from "../../../store/outlet/types";
import useContent from "../../../hooks/useContent";
import "./outlet-picker.scss";

interface IProps {
  outlet?: IOutlet;
  selected: boolean;
  onClick: () => void;
  onFavourite?: (outletId: string, favourite: boolean) => void;
}

const OutletPickerItem = React.forwardRef<HTMLDivElement, IProps>(
  ({ outlet, selected, onClick, onFavourite }, ref) => {
    const { managerAppCommon: content } = useContent();

    const handlePressEnterKey = useCallback(
      (e: React.KeyboardEvent<HTMLDivElement>) => {
        if (e.key === "Enter") {
          onClick();
        }
      },
      [onClick]
    );

    return (
      <div
        ref={ref}
        className={classnames("outlet-item-container", {
          selected
        })}
        tabIndex={0} // make items focusable through sequential keyboard navigation (w/ tab and arrow key)
        title={outlet?.name || content.all_outlets}
        onClick={onClick}
        onKeyPress={handlePressEnterKey}
      >
        {onFavourite && outlet && (
          <Icon
            name={outlet.favourite ? "star-filled" : "star"}
            onClick={e => {
              onFavourite(outlet.id, !outlet.favourite);
              e.stopPropagation();
            }}
            className={`favourite-icon ${outlet.favourite && "selected"}`}
          />
        )}
        <Body className="outlet-item">{outlet?.name || content.all_outlets}</Body>
        {outlet?.newAssociation && <div className="outlet-new-text">{content.common_new}</div>}
      </div>
    );
  }
);

export default OutletPickerItem;
